import React, { useCallback, useRef, useState } from "react";
import { SolarSystemScene } from "./components/scene/SolarSystemScene";
import { AppHeader } from "./components/layout/AppHeader";
import { Sidebar } from "./components/layout/Sidebar";
import { StatusBar } from "./components/layout/StatusBar";
import { BodyDetailsPanel } from "./components/panels/BodyDetailsPanel";
import { SimulationInfoPanel } from "./components/panels/SimulationInfoPanel";
import { PerformancePanel } from "./components/panels/PerformancePanel";
import "./TLSAstronauta.css";

const TLSAstronauta = () => {
  const rootRef = useRef<HTMLDivElement>(null);
  const [fullscreen, setFullscreen] = useState(false);

  const onToggleFullscreen = useCallback(() => {
    const el = rootRef.current;
    if (!el) return;

    if (!document.fullscreenElement) {
      el.requestFullscreen?.()
        .then(() => setFullscreen(true))
        .catch(() => setFullscreen(true));
    } else {
      document.exitFullscreen?.()
        .then(() => setFullscreen(false))
        .catch(() => setFullscreen(false));
    }
  }, []);

  return (
    <div
      ref={rootRef}
      className={`tls-astronauta-root${fullscreen ? " tls-astro-fullscreen" : ""}`}
    >
      <AppHeader onToggleFullscreen={onToggleFullscreen} />
      <div className="tls-astro-body">
        <Sidebar />
        <SolarSystemScene />
        <div className="tls-astro-right">
          <BodyDetailsPanel />
          <SimulationInfoPanel />
          <PerformancePanel />
        </div>
      </div>
      <StatusBar />
    </div>
  );
};

export default TLSAstronauta;
